function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { Fragment, useEffect, useRef, useState } from "react";
import useStyle from "./Label.style";
import { useVisuallyHiddenElementStyle } from "../VisuallyHiddenElement";
import { resolveIds } from "../../utils/resolveIds";
import Tooltip from "../Tooltip/index";
import useComposedRef from "../../hooks/useComposedRef";
var Label = React.forwardRef(function(_param, ref) {
    var children = _param.children, _hasEndIcon = _param.hasEndIcon, hasEndIcon = _hasEndIcon === void 0 ? false : _hasEndIcon, _hasStartIcon = _param.hasStartIcon, hasStartIcon = _hasStartIcon === void 0 ? false : _hasStartIcon, htmlFor = _param.htmlFor, id = _param.id, _isAnimated = _param.isAnimated, isAnimated = _isAnimated === void 0 ? false : _isAnimated, _isDisabled = _param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled, _isRequired = _param.isRequired, isRequired = _isRequired === void 0 ? false : _isRequired, _isRtl = _param.isRtl, isRtl = _isRtl === void 0 ? false : _isRtl, _isInputFocused = _param.isInputFocused, isInputFocused = _isInputFocused === void 0 ? false : _isInputFocused, _isHidden = _param.isHidden, isHidden = _isHidden === void 0 ? false : _isHidden, _requiredIndicator = _param.requiredIndicator, requiredIndicator = _requiredIndicator === void 0 ? '*' : _requiredIndicator, requiredTitle = _param.requiredTitle, testID = _param.testID, _variant = _param.variant, variant = _variant === void 0 ? 'default' : _variant, rest = _objectWithoutProperties(_param, [
        "children",
        "hasEndIcon",
        "hasStartIcon",
        "htmlFor",
        "id",
        "isAnimated",
        "isDisabled",
        "isRequired",
        "isRtl",
        "isInputFocused",
        "isHidden",
        "requiredIndicator",
        "requiredTitle",
        "testID",
        "variant"
    ]);
    var _$ref = useStyle({
        hasEndIcon: hasEndIcon,
        hasStartIcon: hasStartIcon,
        isAnimated: isAnimated,
        isDisabled: isDisabled,
        isRequired: isRequired,
        isRtl: isRtl,
        variant: variant
    }), label = _$ref.label, required = _$ref.required;
    var elementStyle = useVisuallyHiddenElementStyle(false).elementStyle;
    var labelRef = useRef(null);
    var composedRef = useComposedRef(labelRef, ref);
    var _$ref1 = _slicedToArray(useState(false), 2), hasTooltip = _$ref1[0], setHasTooltip = _$ref1[1];
    useEffect(function() {
        var current = labelRef.current;
        if (current) {
            if ((variant === 'outline' || variant === 'underline') && typeof children === 'string' && (current.offsetHeight < current.scrollHeight || current.offsetWidth < current.scrollWidth)) {
                setHasTooltip(true);
            } else {
                setHasTooltip(false);
            }
        }
    }, [
        children,
        variant
    ]);
    if (children === undefined || id === undefined && htmlFor === undefined) {
        return null;
    }
    if (isHidden || !hasTooltip) {
        return _jsx("label", _objectSpread({}, rest, {
            id: id,
            ref: composedRef,
            htmlFor: htmlFor,
            css: isHidden ? [
                label,
                elementStyle
            ] : label
        }, resolveIds(id, testID), {
            children: _jsxs(Fragment, {
                children: [
                    isRequired && _jsx("abbr", {
                        css: required,
                        title: requiredTitle,
                        children: requiredIndicator
                    }),
                    children
                ]
            })
        }));
    }
    return _jsx(Tooltip, {
        placement: "top",
        portal: true,
        text: children,
        trigger: function(handleOpen, handleClose, triggerRef) {
            return _jsx(TooltipLabel, _objectSpread({}, rest, {
                children: children,
                hasEndIcon: hasEndIcon,
                hasStartIcon: hasStartIcon,
                htmlFor: htmlFor,
                id: id,
                isAnimated: isAnimated,
                isDisabled: isDisabled,
                isRequired: isRequired,
                isRtl: isRtl,
                isInputFocused: isInputFocused,
                isHidden: isHidden,
                ref: triggerRef,
                requiredIndicator: requiredIndicator,
                requiredTitle: requiredTitle,
                testID: testID,
                variant: variant,
                handleClose: handleClose,
                handleOpen: handleOpen
            }));
        }
    });
});
export { Label };
var TooltipLabel = React.forwardRef(function(_param, ref) {
    var children = _param.children, handleClose = _param.handleClose, handleOpen = _param.handleOpen, _hasEndIcon = _param.hasEndIcon, hasEndIcon = _hasEndIcon === void 0 ? false : _hasEndIcon, _hasStartIcon = _param.hasStartIcon, hasStartIcon = _hasStartIcon === void 0 ? false : _hasStartIcon, htmlFor = _param.htmlFor, id = _param.id, _isAnimated = _param.isAnimated, isAnimated = _isAnimated === void 0 ? false : _isAnimated, _isDisabled = _param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled, _isRequired = _param.isRequired, isRequired = _isRequired === void 0 ? false : _isRequired, _isRtl = _param.isRtl, isRtl = _isRtl === void 0 ? false : _isRtl, _isInputFocused = _param.isInputFocused, isInputFocused = _isInputFocused === void 0 ? false : _isInputFocused, _isHidden = _param.isHidden, isHidden = _isHidden === void 0 ? false : _isHidden, _requiredIndicator = _param.requiredIndicator, requiredIndicator = _requiredIndicator === void 0 ? '*' : _requiredIndicator, requiredTitle = _param.requiredTitle, testID = _param.testID, _variant = _param.variant, variant = _variant === void 0 ? 'default' : _variant, rest = _objectWithoutProperties(_param, [
        "children",
        "handleClose",
        "handleOpen",
        "hasEndIcon",
        "hasStartIcon",
        "htmlFor",
        "id",
        "isAnimated",
        "isDisabled",
        "isRequired",
        "isRtl",
        "isInputFocused",
        "isHidden",
        "requiredIndicator",
        "requiredTitle",
        "testID",
        "variant"
    ]);
    var _$ref = useStyle({
        hasEndIcon: hasEndIcon,
        hasStartIcon: hasStartIcon,
        isAnimated: isAnimated,
        isDisabled: isDisabled,
        isRequired: isRequired,
        isRtl: isRtl,
        variant: variant
    }), label = _$ref.label, required = _$ref.required;
    var _$ref2 = _slicedToArray(useState(isInputFocused), 2), hasTooltip = _$ref2[0], setHasTooltip = _$ref2[1];
    useEffect(function() {
        if (isInputFocused || hasTooltip) {
            handleOpen === null || handleOpen === void 0 ? void 0 : handleOpen();
        } else {
            handleClose === null || handleClose === void 0 ? void 0 : handleClose();
        }
    }, [
        hasTooltip,
        isInputFocused
    ]);
    return _jsx("label", _objectSpread({}, rest, {
        id: id,
        ref: ref,
        htmlFor: htmlFor,
        css: label
    }, resolveIds(id, testID), {
        onMouseEnter: function() {
            return setHasTooltip(true);
        },
        onMouseLeave: function() {
            return setHasTooltip(false);
        },
        children: _jsxs(Fragment, {
            children: [
                isRequired && _jsx("abbr", {
                    css: required,
                    title: requiredTitle,
                    children: requiredIndicator
                }),
                children
            ]
        })
    }));
});
export default Label;
